import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import { populate, pathReducer } from 'ggApp/utils/pathBuilder';
import loadConfiguration from 'ggApp/utils/configuration';
import { getStoreConfig, isExcludedForSeo } from 'staticStoreConfig';

const { APP_CONFIG } = loadConfiguration();
const { shopHost: host } = APP_CONFIG;

const CanonicalLink = ({ routes, params, activeStore, canonicalBusinessLink, locationQuery }) => {
    const canonicalStore =
        activeStore.code === 'business' && !canonicalBusinessLink
            ? getStoreConfig(activeStore.code).countryCode.toLowerCase()
            : activeStore.code;
    const parameterizedPath = pathReducer(routes);
    const path = populate(parameterizedPath, {
        ...params,
        store: canonicalStore,
        language: params.language,
    });
    const paginationQuery = locationQuery?.page && `?page=${locationQuery?.page}`;
    let fullPath = paginationQuery ? path + paginationQuery : path;

    const isHiddenForSeo = isExcludedForSeo(activeStore);
    if (isHiddenForSeo) {
        return null;
    }

    if (params?.categorySlug === 'drones' && params?.subCategorySlug === 'for-pro') {
        fullPath = fullPath.replace('/for-pro', '');
    }

    return <Helmet>{<link rel="canonical" href={`${host}${fullPath}`} />}</Helmet>;
};

CanonicalLink.propTypes = {
    routes: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    params: PropTypes.shape({
        language: PropTypes.string,
    }),
    activeStore: PropTypes.shape({
        code: PropTypes.string,
    }),
};

CanonicalLink.defaultProps = {
    routes: {},
    params: {},
    activeStore: {},
};

export default CanonicalLink;
